import { c as _c } from "react/compiler-runtime";
import { QuestionNumber, Answer, EditButton, NoAnswerInline } from '../AnsweredQuestionParts';
import { QuestionMethods } from '../questionMethods.types';
import { RenderedSingleSelectQuestion, SingleSelectGivenAnswer } from './singleSelectMethods.types';
export const AnsweredQuestionSingle: QuestionMethods<RenderedSingleSelectQuestion, SingleSelectGivenAnswer>['Answered'] = t0 => {
  const $ = _c(19);
  const {
    question,
    givenAnswer,
    onEdit
  } = t0;
  let t1;
  if ($[0] !== givenAnswer || $[1] !== question.answers) {
    let t2;
    if ($[3] !== givenAnswer) {
      t2 = answer => answer.id === givenAnswer;
      $[3] = givenAnswer;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = question.answers.find(t2);
    $[0] = givenAnswer;
    $[1] = question.answers;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const answer_0 = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <QuestionNumber />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== answer_0) {
    t3 = answer_0 ? answer_0.fullTitle : <NoAnswerInline />;
    $[6] = answer_0;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <Answer>{t3}</Answer>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== onEdit || $[11] !== question.id) {
    t5 = () => onEdit(question.id);
    $[10] = onEdit;
    $[11] = question.id;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== question.title || $[14] !== t5) {
    t6 = <EditButton onClick={t5} questionTitle={question.title} />;
    $[13] = question.title;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t6) {
    t7 = <>{t2}{t4}{t6}</>;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};